import Table, {TableCell, TableRow} from "@amzn/meridian/table";
import React, {useState} from "react";
import {ITEMS_PER_PAGE} from "../../constants";
import Pagination from "@amzn/meridian/pagination";

export default function AvgHCAllocation({hcCsvData}) {
    //For pagination
    const itemsPerPage = ITEMS_PER_PAGE;
    const numberOfPages = Math.ceil(hcCsvData.length / itemsPerPage);
    const [currentPage, setCurrentPage] = useState(1);
    const firstVisibleIndex = (currentPage - 1) * itemsPerPage;
    const lastVisibleIndex = firstVisibleIndex + itemsPerPage;
    //Pagination
    console.log(hcCsvData);
    return (<>
        <Table
            showStripes={true}
            headerRows={1}
            showDividers={true}
            spacing={"small"}
        >
            <TableRow>
                <TableCell width={70}>Sort Center</TableCell>
                <TableCell width={100}>Shift</TableCell>
                <TableCell width={150}>Role</TableCell>
                <TableCell width={70}>Head Count</TableCell>
            </TableRow>
            {hcCsvData &&
                hcCsvData.slice(firstVisibleIndex, lastVisibleIndex).map((parsedData, index) => {
                    return <TableRow key={index}>
                        <TableCell>{parsedData['Sort_center']}</TableCell>
                        <TableCell>{parsedData['Shift']}</TableCell>
                        <TableCell>{parsedData['Role']}</TableCell>
                        <TableCell>{parsedData['HC']}</TableCell>
                    </TableRow>
                })}
        </Table>
        <Pagination
            showSkipArrows={true}
            numberOfPages={numberOfPages}
            onChange={setCurrentPage}
            currentPage={currentPage}
        />
    </>);
};
